import { ToastContainer } from '@components'

import { DRAWER_EXPANDED_LEFT_OFFSET_CSS_VAR, ModalContextProvider, rwd } from '@billy/design-system'
import { ReactElement, useEffect } from 'react'

import { ExpertReportTracking } from '@features/expertReports'
import { UserOrganizationSettingsContextProvider, useUserOrganization } from '@modules-deprecated/app/organization'

import { ThemeProvider } from '../../../../contexts/themeProvider'
import { useReactEmberRouterConnection } from '../../../../hooks/useReactEmberRouterConnection'
import { useSegmentPageEvent } from '../../../../hooks/useSegmentPageEvent'
import { GlobalVirtualAssistant } from '../GlobalVirtualAssistant'

const NAV_SIDEBAR_WIDTH = '232px'

export const GlobalApplication = (): ReactElement => {
  useReactEmberRouterConnection()
  useSegmentPageEvent()
  const { organization } = useUserOrganization()

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${rwd.getBreakpointValue('xlarge')}px)`)
    const apply = () => {
      document.documentElement.style.setProperty(
        DRAWER_EXPANDED_LEFT_OFFSET_CSS_VAR,
        mediaQuery.matches ? NAV_SIDEBAR_WIDTH : '0px',
      )
    }
    apply()
    mediaQuery.addEventListener('change', apply)
    return () => mediaQuery.removeEventListener('change', apply)
  }, [])

  return (
    <UserOrganizationSettingsContextProvider organizationId={organization?.id}>
      <ExpertReportTracking />
      <ThemeProvider>
        <ToastContainer />
        <ModalContextProvider>
          <GlobalVirtualAssistant key={organization?.id} />
        </ModalContextProvider>
      </ThemeProvider>
    </UserOrganizationSettingsContextProvider>
  )
}
